// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFilterFromJSON, DatapointFilterToJSON, DatapointsRequestItemFromJSON, DatapointsRequestItemToJSON, } from './';
export function DatapointsRequestSpecificsFromJSON(json) {
    return {
        'requests': json['requests'].map(DatapointsRequestItemFromJSON),
        'filters': !exists(json, 'filters') ? undefined : json['filters'].map(DatapointFilterFromJSON),
    };
}
export function DatapointsRequestSpecificsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'requests': value.requests.map(DatapointsRequestItemToJSON),
        'filters': value.filters === undefined ? undefined : value.filters.map(DatapointFilterToJSON),
    };
}
